'use client'
import { hubHandler } from '@core/auth/utils'
import { hermesLogger } from '@core/observability'
import { useGetHubsLazyQuery } from '@data/generated-hooks'

import {
  IHubList,
  UseGetHubsListHookResponse,
} from './use-get-hubs-list.hook.types'

export function useGetHubsList(): UseGetHubsListHookResponse {
  const { setHubsList, setDefaultHub } = hubHandler()

  const [getHubs, { loading: isLoading, error }] = useGetHubsLazyQuery({
    onCompleted: ({ hubs }) => {
      if (hubs?.length) {
        const hubList: IHubList = Array.from(hubs).sort((a, b) =>
          a.alias.localeCompare(b.alias)
        ) as IHubList
        setHubsList(hubList)
        setDefaultHub()
      } else {
        const error = new Error('Unregistered Hubs to this user')
        hermesLogger.error('[useHub] Error in get hubs to the user', {
          error,
        })
        throw error
      }
    },
    onError: (err) => {
      hermesLogger.error('[useHub] Error in get hubs to the user', {
        error: err,
      })
    },
  })

  async function fetchHubs(): Promise<void> {
    try {
      await getHubs()
    } catch (error) {
      hermesLogger.error('[useHub] Error in get hubs to the user', {
        error,
      })
    }
  }

  return {
    fetchHubs,
    isLoading,
    error,
  }
}
